// The canvas zoom — 05i-2. main.js's setZoom and the slider on the right edge, copied
// exactly. The zoom is a plain value here (not the store): it isn't part of an undo step,
// and the canvas space, the move, the resize and drag-to-add read it fresh when they need it.

import { STEP } from "./placement.js";
import { DEFAULT_ZOOM_IDX, SCALE_VALUES, clampZoomIdx, gridBackground, thumbTop, zoomIdxAt } from "./zoom-rules.js";

let zoomIdx = DEFAULT_ZOOM_IDX;
let scale = SCALE_VALUES[DEFAULT_ZOOM_IDX]!;
let zooming = false;

/** The canvas's current scale (1 = 100%). */
export const getScale = (): number => scale;
/** The current step, 0–4 (the tour reads it). */
export const getZoomIdx = (): number => zoomIdx;

function byId(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`#${id} missing from legacy-scaffold.html`);
  return el;
}

function thumb(): HTMLElement {
  const el = document.querySelector<HTMLElement>(".zoom-thumb");
  if (!el) throw new Error(".zoom-thumb missing from legacy-scaffold.html");
  return el;
}

/** Zoom the canvas to step `idx` (rounded, kept within the 5): the canvas's scale, the page's
 *  grid background, the slider's dots and thumb. */
export function setZoom(idx: number): void {
  zoomIdx = clampZoomIdx(idx);
  scale = SCALE_VALUES[zoomIdx]!;
  byId("workspace").style.transform = `scale(${scale})`;
  const bg = gridBackground(scale, STEP);
  document.documentElement.style.backgroundSize = bg.size;
  document.documentElement.style.backgroundPosition = bg.position;
  document.querySelectorAll<HTMLElement>(".zoom-dot").forEach((dot, i) => {
    dot.style.background = i === zoomIdx ? "#2ecc71" : "#555";
  });
  thumb().style.top = thumbTop(zoomIdx);
}

function zoomToPointer(e: PointerEvent): void {
  setZoom(zoomIdxAt(e.clientY - byId("zoom-widget").getBoundingClientRect().top));
}

/**
 * The slider: a press on it (a dot, the line, the thumb or the widget itself) zooms to that
 * step and starts a drag; moves anywhere on the page follow until the release. Installed
 * before main.js loads, where main.js added its listeners — so the page-wide move / release
 * still run before the resize halo's.
 */
export function installZoom(): void {
  const widget = byId("zoom-widget");
  const t = thumb();
  widget.addEventListener("pointerdown", (e) => {
    const target = e.target as HTMLElement;
    if (target.classList.contains("zoom-dot") || target === t || target === widget || target.classList.contains("zoom-line")) {
      zooming = true;
      t.classList.add("dragging");
      zoomToPointer(e);
      e.preventDefault();
    }
  });
  document.addEventListener("pointermove", (e) => {
    if (zooming) zoomToPointer(e);
  });
  document.addEventListener("pointerup", () => {
    if (!zooming) return;
    zooming = false;
    t.classList.remove("dragging");
  });
}

